import React, {useEffect, useState, Fragment} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { translate } from 'react-i18next';
import RelatedRecipes from '../../../components/Recipes/RelatedRecipes';
import BaseLayout from '../../../components/Layout/BaseLayout';
import AdCoreSlot from '../../../components/Ads/AdCoreSlot';
import FeedSwitcherComponent from '../../../components/Layout/Sidebars/FeedSwitcher';
import {Icon} from '../../../components/Common/Icon';
import Template404Container from '../../404';
import Template404 from '../../../components/404';
import {RecipeDetailPlaceholder} from '../../../components/Common/ContentPlaceholder';
import { recipeDetailDataFetch, topicTrendingListFetch } from '../../../actions/index';
import {mobileCheck, gtmSend, getUrlImage} from '../../../helpers';
import cx from '../../../styles';
import Breadcrumbs from '../../../components/Layout/Breadcrumbs';

export const RecipeDetail = (props) => {
	
	const [isDetailEmpty, setIsDetailEmpty] = useState(false);

	useEffect(() => {
		if(props.id){
			props.recipeDetailDataFetch(props.id)
			.then((response) => {
				if(!(response && response.detail)){
					setIsDetailEmpty(true);
				}
			});
		}
	},[props.id]);

    const onTagClick = (type, slug, id) => {
        gtmSend('dynamic event', 'Recipes', 'Recipe detail tag click', `/${type}/${slug}/${id}`);
        window.scrollTo(0,0);

        if(mobileCheck()) {
        	if(props.toggleIsShowDetail){
        		props.toggleIsShowDetail();
        	}
            const url = `/recipes/${type}/${slug}/${id}`;
            window.history.pushState({}, "", url);
        }
        else {
            props.history.push(`/recipes/${type}/${slug}/${id}`);
        }
    };

    const recipeDetail = props.recipeReducer.selectedRecipe ? props.recipeReducer.selectedRecipe.detail : null;
	const relatedRecipes = props.recipeReducer.selectedRecipe ? props.recipeReducer.selectedRecipe.related : null;

	if(isDetailEmpty){
		return (
			<Template404 t={props.t} />
		);
	}
	else{
		return (
			<div className={cx('recipe-detail-container')}>
	    		<div className={cx('recipe-detail-wrapper')}>
		            {
		            	!props.recipeReducer.isLoading && recipeDetail
		            	?
			            	<Fragment>
			                    <div className={cx('recipe-detail-image')} style={{backgroundImage: `url(${recipeDetail.images ? recipeDetail.images[0] : getUrlImage({imgPath: "community-theasianparent/assets/food_placeholder.png"})})`}}>
			                        <img className={cx('glass')} src={getUrlImage({imgPath: 'tap-assets/glass-featured-prime-block.png'})} alt="glass-placeholder" loading="lazy" />
			                    </div>
			                    <div className={cx('category-detail-wrap')}>
			                        <h1 className={cx('recipe-name')}>{recipeDetail.label}</h1>
			                        <div className={cx('tag-wrap')}>
			                        	{
			                        		recipeDetail.tags &&
			                        		recipeDetail.tags.map(tag => {
			                        			return (
			                        				<div key={tag.label} className={cx('recipe-tag')}>
			                        					<a href={`/recipes/${tag.type}/${tag.slug}/${tag.key}`} onClick={() => onTagClick(tag.type, tag.slug, tag.key)} aria-label="Click to view recipe collection" >
			                        						{tag.label}
			                        					</a>
			                        				</div>
			                        			);
			                        		})
			                        	}
			                        </div>
			                        {
			                        	recipeDetail.properties &&
			                        	<div className={cx('properties-wrap')}>
			                        		{
			                        			recipeDetail.properties.map(property => {
			                        				return (
			                        					<div key={property.key} className={cx('recipe-property')}>
			                        						<img src={property.icon} alt={property.key} loading="lazy"/>
			                        						<span>{property.label}</span>
			                        					</div>
			                        				);
			                        			})
			                        		}
			                        	</div>
			                        }
			                    </div>
			                    <div className={cx('recipe-detail-wrap')}>
			                    	{
			                    		recipeDetail.ingredients &&
			                    		<Fragment>
				                    		<h2 className={cx('title')}>{props.t('ingredients')}</h2>
				                    		<ul className={cx('recipe-ingredients')}>
					                    		{
					                    			recipeDetail.ingredients.map((ingredient, index) => {
					                    				return (
					                    					<li key={index} className={cx('each-ingredient')}>
					                    						{
					                    							ingredient.image
					                    							?
					                    								<div className={'ingredient-image'} style={{backgroundImage: `url(${ingredient.image})`}} />
					                    							:
					                    								<div className={'bullets'} />
					                    						}
					                    						<div className={'points'}>{ingredient.label}</div>
					                    					</li>
					                    				);
					                    			})
					                    		}
					                    	</ul>
				                    	</Fragment>
				                    }

			                    	{
			                    		recipeDetail.steps &&
			                    		<Fragment>
				                    		<h2 className={cx('title')}>{props.t('steps')}</h2>
				                    		<ol className={cx('recipe-steps')}>
					                    		{
					                    			recipeDetail.steps.map((step) => {
					                    				return (
					                    					<li key={step.step_number} className={cx('each-step')}>
					                    						<div className={'bullets'} />
					                    						<div className={'points'}>
					                    							{
					                    								step.image &&
					                    								<div className={cx('step-image')} style={{backgroundImage: `url(${step.image})`}} />
					                    							}
					                    							<div>{step.description}</div>
					                    						</div>
					                    					</li>
					                    				);
					                    			})
					                    		}
					                    	</ol>
				                    	</Fragment>
				                    }
			                    </div>

			                    {
			                    	recipeDetail.allergic_label &&
				                    <div className={cx('allergic-label')}>
				                    	<Icon name='warning-triangle' />
				                    	<div>{recipeDetail.allergic_label}</div>
				                    </div>
			                	}
			                </Fragment>
			            :
			            	<RecipeDetailPlaceholder />
		            }
	            </div>

	            <div className={cx('only-mobile', 'related-recipes-mobile')}>
	            	<RelatedRecipes related={relatedRecipes} t={props.t} history={props.history} />
	            </div>

				<Breadcrumbs links={[
						{ location: '/feed', label: 'Home' },
						{ location: '/recipes', label: 'Recipes' },
						{ location: `/recipes/cuisine/${recipeDetail ? `${recipeDetail.cuisine_slug}/${recipeDetail.cuisine_id}` : ''}`, label: (recipeDetail ?  recipeDetail.cuisine : '') },
						{ location: `/recipe/${recipeDetail ? `${recipeDetail.slug}/${recipeDetail.id}` : ''}`, label: (recipeDetail ?  recipeDetail.label : '')}
					]} />
	    	</div>
		);
	}
};

const RecipeDetailContainer = (props) => {

	const [isDetailEmpty, setIsDetailEmpty] = useState(false);

	useEffect(() => {
		window.scrollTo(0,0);
		const {detail} = props.recipeReducer.selectedRecipe;
		if(!(detail && detail.id) || 
			(detail && detail.id !== props.match.params.id)){
			props.recipeDetailDataFetch(props.match.params.id)
			.then((response) => {
				if(!(response && response.detail)){
					setIsDetailEmpty(true);
				}
			});
		}
		requestSidebars();
	},[props.match.params.id]);

	const relatedRecipes = props.recipeReducer.selectedRecipe ? props.recipeReducer.selectedRecipe.related : null;

	const requestSidebars = () => {
		if(!(mobileCheck() || props.appReducer.topicsTrendingSidebar.length)){
			props.topicTrendingListFetch();
		}
	};

	const buildLeftSidebar = () => {
        const lc = [
            <FeedSwitcherComponent trendingTopicsElems={props.appReducer.topicsTrendingSidebar} appReducer={props.appReducer} />,
        ];

        return lc;
    };

    const buildRightSidebar = () => {
    	const ads = props.configReducer.ads;
    	const rc = [
    		<RelatedRecipes related={relatedRecipes} t={props.t} history={props.history} />,
    		ads.networkId &&
    		<div className={cx("shadow-card")}>
                <AdCoreSlot networkId={ads.networkId} 
                    adUnit={ads.common.half_page.unit}
                    styleClass={ads.common.half_page.styleClass}
                    size={[ads.common.half_page.w, ads.common.half_page.h]}
                    id={ads.common.half_page.id}/>
            </div>
    	];

    	return rc;
    };

    if(isDetailEmpty){
    	return (
    		<Template404Container history={props.history} match={props.match} />
    	);
    }
    else{
		return (
			<BaseLayout 
	            history={props.history} 
	            match={props.match}
	            landingUrl={props.landingUrl}
	            serverReqCookie={props.serverReqCookie}
	            className={'recipe-detail-page'}
	            leftCards={buildLeftSidebar()}
	            rightCards={buildRightSidebar()}
	        >
            	<div className={cx('detail-title-wrap')}>
	                <span className={cx('close','not-mobile')} onClick={() => {props.history.goBack(); gtmSend('dynamic','Recipes','back button click','');}}><Icon name='btn-back'/></span>
	                <span className={cx('close', 'only-mobile')} onClick={() => {props.history.goBack(); gtmSend('dynamic','Recipes','back button click','');}}><Icon name="btn-back"/></span>
	            </div>
            	<RecipeDetail 
            		recipeReducer={props.recipeReducer} 
            		t={props.t}
            		match={props.match} 
            		history={props.history} />
	        </BaseLayout>
		);
	}
};

// map state
const mapStateToProps = (state) => state;

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		recipeDetailDataFetch,
		topicTrendingListFetch
	},dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(RecipeDetailContainer));